import axios from '@/utils/axios';
import { PaymentTransaction } from '../types';

type PaginationMeta = {
  total?: number;
  per_page?: number;
  current_page?: number;
  last_page?: number;
};

export type GetTransactionsParams = Partial<{
  status: string;
  type: string;
  source: string;
  search: string;
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: string;
}>;

export type TransactionsListResponse = {
  data: PaymentTransaction[];
  meta?: PaginationMeta | null;
};

export async function getTransactions(
  params?: GetTransactionsParams
): Promise<TransactionsListResponse> {
  const response = await axios.get('/transactions', {
    params,
  });

  const payload = response?.data ?? {};
  const collectionCandidates = [
    payload?.data,
    payload?.results,
    payload?.items,
    payload?.transactions,
    payload,
  ];

  const collection = collectionCandidates.find(Array.isArray) as
    | PaymentTransaction[]
    | undefined;

  return {
    data: collection ?? [],
    meta: payload?.meta ?? payload?.pagination ?? null,
  };
}

export async function deleteTransaction(transactionId: number): Promise<void> {
  await axios.delete(`/transactions/${transactionId}`);
}
